/**
 * Configuration centralisée pour tous les formulaires
 * Permet de changer facilement de service d'envoi de formulaires
 */

export const FORM_ENDPOINT = "/form-handler.php";

// URLs de redirection après succès (utilisées en fallback si mode fetch n'est pas utilisé)
export const FORM_SUCCESS_REDIRECTS = {
  contact: `${window.location.origin}/contact?message=success`,
  callback: `${window.location.origin}/?callback=success`,
  appointment: `${window.location.origin}/?appointment=success`,
} as const;

/**
 * Validation anti-spam honeypot
 * Retourne true si le champ honeypot est rempli (= probable spam)
 */
export const isSpamSubmission = (honeypotValue: string): boolean => {
  return honeypotValue.trim().length > 0;
};
